import api from "@/api.js";

export default {
  state: {
    magazines: [],
    magazinesLoading: false,
    magazinesIndustrial: [],
    magazinesIndustrialLoading: false,
  },
  mutations: {
    setMagazines(state, payload) {
      state.magazines = payload;
    },
    setMagazinesLoading(state, loading) {
      state.magazinesLoading = loading;
    },
    setMagazinesIndustrial(state, payload) {
      state.magazinesIndustrial = payload;
    },
    setMagazinesIndustrialLoading(state, loading) {
      state.magazinesIndustrialLoading = loading;
    },
  },
  actions: {
    async loadMagazines({ commit, state }) {
      commit("setMagazinesLoading", true);
      let magazines = await api.get("magazines");
      commit("setMagazines", magazines.data);
      commit("setMagazinesLoading", false);
    },
    async loadIndustrialMagazines({ commit, state }) {
      commit("setMagazinesIndustrialLoading", true);
      let magazines = await api.get("magazines/industrial");
      commit("setMagazinesIndustrial", magazines.data);
      commit("setMagazinesIndustrialLoading", false);
    },
    async saveMagazine({ commit, dispatch }, payload) {
      let returnData;
      await api
        .put("magazines", payload)
        .then((result) => {
          returnData = {
            Result: "Success",
            Response: result,
          };
          return returnData;
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
          return returnData;
        });
      dispatch("loadMagazines");
      dispatch("loadIndustrialMagazines");
      return returnData;
    },
    async newMagazine({ commit, dispatch }, payload) {
      let returnData;
      await api
        .post("magazines", payload)
        .then((result) => {
          returnData = {
            Result: "Success",
            Response: result,
            id: result.data.magazines_id,
          };
          return returnData;
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
          return returnData;
        });

      return returnData;
    },
    async magazinesUpload({ commit }, payload) {
      let returnData;
      await api
        .post("magazines/upload", payload)
        .then((result) => {
          returnData = {
            Result: "Success",
            Response: result,
          };
          return returnData;
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
          return returnData;
        });
      return returnData;
    },
    async deleteMagazine({ commit, dispatch }, payload) {
      let returnData;
      await api
        .post("magazines/delete", payload)
        .then((result) => {
          returnData = {
            Result: "Success",
            Response: result,
            id: result.data.magazines_id,
          };
          return returnData;
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
          return returnData;
        });

      dispatch("loadMagazines");
      dispatch("loadIndustrialMagazines");

      return returnData;
    },
  },
  getters: {
    magazines(state) {
      return state.magazines;
    },
    magazinesLoading(state) {
      return state.magazinesLoading;
    },
    magazinesIndustrial(state) {
      return state.magazinesIndustrial;
    },
    magazinesIndustrialLoading(state) {
      return state.magazinesIndustrialLoading;
    },
  },
};
